import { cn } from "@/lib/utils";

export function CompletedIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-5.5 w-[29px] text-white", className)}
      viewBox="0 0 29 22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M3.483 10.843C1.643 8.894-1.3 11.863.632 13.719c2.391 2.505 4.782 5.103 7.265 7.516 1.104 1.02 1.932 1.02 2.944 0l17.566-17.63c1.84-1.948-1.012-4.917-2.943-2.969L9.46 16.781l-5.978-5.938z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function DislikeIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-2.5 text-white", className)}
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M7.017 5.33V1.62c0-.202.168-.37.371-.37h1.668c.203 0 .371.167.371.37v3.71a.374.374 0 01-.371.371H7.388a.374.374 0 01-.371-.371zM1.269 6.443h1.605c-.134.534-.492.737-.492 1.483 0 1.36 1.55 2.521 1.94.429.117-.564 1.4-2.603 1.97-2.648a.387.387 0 00.353-.371V1.622a.38.38 0 00-.37-.37c-.203-.007-.55-.128-.915-.256C4.733.782 3.95.51 3.123.51 2.048.509.831.309.952 1.827.387 2.015-.051 2.87.387 3.522c-.565.565-.464 1.127 0 1.695 0 0-.377.942.882 1.226z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function LikeIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-2.5 text-white", className)}
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M2.41 4.67v3.71c0 .202-.167.37-.37.37H.37A.373.373 0 010 8.379V4.67c0-.203.168-.37.371-.37H2.04c.204 0 .372.168.372.371zm5.749-1.113H6.554c.133-.534.492-.737.492-1.483 0-1.36-1.55-2.521-1.941-.429-.117.564-1.4 2.603-1.97 2.648a.387.387 0 00-.353.371v3.714a.38.38 0 00.37.37c.203.007.551.128.915.256.627.214 1.409.487 2.237.487 1.075 0 2.292.2 2.172-1.318.565-.188 1.003-1.043.565-1.695.565-.565.463-1.127 0-1.695 0 0 .376-.942-.882-1.226z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function LoveIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-2.5 w-[11px] text-white", className)}
      viewBox="0 0 11 10"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.5 9.306c.196 0 .494-.182.783-.378C8.799 7.255 10.5 5.242 10.5 3.23 10.5 1.277 9.125 0 7.56 0 6.58 0 5.9.536 5.5 1.29 5.104.54 4.419 0 3.44 0 1.875 0 .5 1.277.5 3.23c0 2.012 1.7 4.025 4.217 5.698.29.196.587.378.783.378z"
        fill="currentColor"
      />
      <path
        d="M3.44 0c.98 0 1.664.54 2.06 1.29 0 0-6.04.41-.783 7.638C2.201 7.255.5 5.242.5 3.23.5 1.277 1.875 0 3.44 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PlayedIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 text-white", className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="10.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M7.382 12.66l2.639 2.639L16.618 8.7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function SaveIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[23px] w-3.5 text-white", className)}
      fill="none"
      viewBox="0 0 14 23"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.286 1H2.714C1.771 1 1 2 1 3.222V21l6-3.333L13 21V3.222C13 2 12.229 1 11.286 1z"
        stroke="currentColor"
        strokeWidth="1.3"
      />
    </svg>
  );
}

export function SavedIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[9px] w-[5px] text-white", className)}
      viewBox="0 0 5 9"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.286 0H.714C.321 0 0 .45 0 1v8l2.5-1.5L5 9V1c0-.55-.321-1-.714-1z"
        fill="currentColor"
      />
    </svg>
  );
}
